import React from 'react';
import PropTypes from 'prop-types'

import ticketStatusConstants from '../../../utils/ticketStatusConstants.js';
import verificationStatusConstants from '../../../utils/verificationStatusConstants.js';

/**
 * The TicketViewActions component.
 *
 * @constructor
 */
export class TicketViewActions extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const processStatus = this.props.processStatus;
    const processingRequest = this.props.processingRequest || false;

    return (
      <div className="ticket-view-actions">
        {(processStatus === ticketStatusConstants.awaitingReview ||
          processStatus === verificationStatusConstants.awaitingReview ||
          processStatus === verificationStatusConstants.skipped) && (
            <div>
              <h3>Is the information above correct?</h3>
              <div className="large expanded button-group verify-button-group">
                <button
                  type="button"
                  className="button accept-button"
                  disabled={processingRequest}
                  onClick={this.props.approveTicket}
                >Yes</button>

                <button
                  type="button"
                  className="button reject-button"
                  disabled={processingRequest}
                  onClick={this.props.requestChange}
                >No</button>
              </div>
            </div>
          )}

        {(processStatus === ticketStatusConstants.pendingChange ||
          processStatus === verificationStatusConstants.pendingChange) && (
            <div>
              <h3>You have a pending change request. Need to make an additional change?</h3>
              <button
                type="button"
                className="button large expanded change-button"
                disabled={processingRequest}
                onClick={this.props.requestChange}
              >Request Change</button>
            </div>
          )}

        {(processStatus === ticketStatusConstants.confirmed ||
          processStatus === verificationStatusConstants.complete) && (
            <div>
              <h3>You have confirmed your information. Need to make a change?</h3>
              <button
                type="button"
                className="button large expanded change-button"
                disabled={processingRequest}
                onClick={this.props.requestChange}
              >Request Change</button>
            </div>
          )}
      </div>
    );
  }
}

TicketViewActions.propTypes = {
  approveTicket: PropTypes.func.isRequired,
  requestChange: PropTypes.func.isRequired,
  processStatus: PropTypes.string.isRequired,
  processingRequest: PropTypes.bool,
};

export default TicketViewActions;



// WEBPACK FOOTER //
// ./src/components/ticket/ticketViewActions/TicketViewActions.js